import { useParams } from 'react-router-dom'
import StageContracts from './common/StageContracts'
import StageLocations from './common/StageLocations'
import EntityStage from './common/StageTender'

const StageWrapper = () => {
	const { departmentId } = useParams()

	const getStageByDepartmentId = () => {
		switch (departmentId) {
			case 'tender':
				return EntityStage
			case 'projects':
				return EntityStage
			case 'contracts':
				return StageContracts
			case 'locations':
				return StageLocations
			default:
				return null
		}
	}

	const StageComponent = getStageByDepartmentId()

	return (
		<section className='workspace__wrapper'>
			<StageComponent />
		</section>
	)
}
export default StageWrapper
